var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import './IframeContainer.scss';
import { Spinner } from '@sitebase/ui-kit';
import { CLASSNAME_PREFIX } from './componentConfig';
var IframeContainer = function (props) {
    var _a = __read(React.useState(true), 2), iframeLoading = _a[0], iframeLoaded = _a[1];
    return (React.createElement("div", { className: CLASSNAME_PREFIX + "-component" },
        iframeLoading && (React.createElement("span", { className: CLASSNAME_PREFIX + "-component__spinner" },
            React.createElement(Spinner, null))),
        props.iframeLink && (React.createElement("iframe", { src: props.iframeLink, width: "100%", height: "100%", allow: "camera;fullscreen;accelerometer;gyroscope;magnetometer", allowFullScreen: true, onLoad: function () { return iframeLoaded(false); } }))));
};
export default IframeContainer;
//# sourceMappingURL=IframeContainer.js.map